import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {SearchModel} from '../views/models/search.model';
import {environment} from '../../environments/environment';

@Injectable({providedIn: 'root'})
export class SearchService {
  search_change$ = new BehaviorSubject<SearchModel[]>([]);
  loading_change$ = new BehaviorSubject<boolean>(false);


  constructor(private httpClient: HttpClient) {
  }

  getSerach(item: string) {
    this.loading_change$.next(true);
    this.httpClient.get(environment.baseURL + '/v2/api' + '/search/' + item).subscribe(
      (data: SearchModel[]) => {
        this.loading_change$.next(false);
        console.log(this.loading_change$.getValue());
        if (data != null) {
          this.search_change$.next(data);
        } else {
          this.search_change$.next([]);
        }
      }
    );
  }
}
